/**
 * Énumérations partagées entre le frontend et le backend.
 * Ces valeurs doivent rester alignées avec les `enum` du schéma Prisma.
 */
/** Rôles utilisateur (code interne = clé stable). */
export const Role = {
    ADMIN: 'ADMIN',
    RECEPTIONIST: 'RECEPTIONIST',
    MECHANIC: 'MECHANIC',
    STOREKEEPER: 'STOREKEEPER',
    ACCOUNTANT: 'ACCOUNTANT',
};
export const ROLE_LABELS = {
    ADMIN: 'Administrateur',
    RECEPTIONIST: 'Réceptionnaire',
    MECHANIC: 'Mécanicien',
    STOREKEEPER: 'Magasinier',
    ACCOUNTANT: 'Comptable',
};
/** Statuts d'un rendez-vous. */
export const AppointmentStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
export const APPOINTMENT_STATUS_LABELS = {
    PENDING: 'En attente',
    CONFIRMED: 'Confirmé',
    IN_PROGRESS: 'En cours',
    COMPLETED: 'Terminé',
    CANCELLED: 'Annulé',
};
/** Priorité (rendez-vous / ordre de réparation). */
export const Priority = {
    LOW: 'LOW',
    NORMAL: 'NORMAL',
    HIGH: 'HIGH',
    URGENT: 'URGENT',
};
/** Type de ligne d'un ordre de réparation / d'une facture. */
export const RepairLineType = {
    PART: 'PART',
    LABOR: 'LABOR',
    OTHER: 'OTHER',
};
export const REPAIR_LINE_TYPE_LABELS = {
    PART: 'Pièce',
    LABOR: 'Main d\'œuvre',
    OTHER: 'Autre',
};
export const REPAIR_ORDER_STATUS_LABELS = {
    DRAFT: 'Brouillon',
    IN_PROGRESS: 'En cours',
    ON_HOLD: 'En attente',
    COMPLETED: 'Terminé',
    INVOICED: 'Facturé',
    CANCELLED: 'Annulé',
};
/** Statuts d'un ordre de réparation. */
export const RepairOrderStatus = {
    DRAFT: 'DRAFT',
    IN_PROGRESS: 'IN_PROGRESS',
    ON_HOLD: 'ON_HOLD',
    COMPLETED: 'COMPLETED',
    INVOICED: 'INVOICED',
    CANCELLED: 'CANCELLED',
};
/** Type de document de facturation. */
export const DocumentType = {
    QUOTE: 'QUOTE', // Devis
    INVOICE: 'INVOICE', // Facture
    CREDIT_NOTE: 'CREDIT_NOTE', // Avoir
    RECEIPT: 'RECEIPT', // Reçu
};
export const DOCUMENT_TYPE_LABELS = {
    QUOTE: 'Devis',
    INVOICE: 'Facture',
    CREDIT_NOTE: 'Avoir',
    RECEIPT: 'Reçu',
};
/** Statut d'un document de facturation. */
export const InvoiceStatus = {
    DRAFT: 'DRAFT',
    ISSUED: 'ISSUED',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    CANCELLED: 'CANCELLED',
};
export const INVOICE_STATUS_LABELS = {
    DRAFT: 'Brouillon',
    ISSUED: 'Émise',
    PARTIALLY_PAID: 'Partiellement payée',
    PAID: 'Payée',
    OVERDUE: 'En retard',
    CANCELLED: 'Annulée',
};
/** Moyens de paiement. */
export const PaymentMethod = {
    CASH: 'CASH',
    WAVE: 'WAVE',
    ORANGE_MONEY: 'ORANGE_MONEY',
    CARD: 'CARD',
    MOBILE_MONEY: 'MOBILE_MONEY',
    CHECK: 'CHECK',
    TRANSFER: 'TRANSFER',
};
export const PAYMENT_METHOD_LABELS = {
    CASH: 'Espèces',
    WAVE: 'Wave',
    ORANGE_MONEY: 'Orange Money',
    CARD: 'Carte bancaire',
    MOBILE_MONEY: 'Mobile Money',
    CHECK: 'Chèque',
    TRANSFER: 'Virement',
};
/** Sens d'un mouvement de stock. */
export const StockMovementType = {
    IN: 'IN', // Entrée
    OUT: 'OUT', // Sortie
    ADJUSTMENT: 'ADJUSTMENT', // Inventaire / correction
};
export const STOCK_MOVEMENT_LABELS = {
    IN: 'Entrée',
    OUT: 'Sortie',
    ADJUSTMENT: 'Inventaire',
};
/** Statut d'une commande fournisseur. */
export const PurchaseStatus = {
    DRAFT: 'DRAFT',
    ORDERED: 'ORDERED',
    PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
    RECEIVED: 'RECEIVED',
    CANCELLED: 'CANCELLED',
};
export const PURCHASE_STATUS_LABELS = {
    DRAFT: 'Brouillon',
    ORDERED: 'Commandée',
    PARTIALLY_RECEIVED: 'Partiellement reçue',
    RECEIVED: 'Reçue',
    CANCELLED: 'Annulée',
};
/** Statut de présence d'un employé. */
export const AttendanceStatus = {
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT',
    LATE: 'LATE',
    LEAVE: 'LEAVE',
};
export const ATTENDANCE_STATUS_LABELS = {
    PRESENT: 'Présent',
    ABSENT: 'Absent',
    LATE: 'En retard',
    LEAVE: 'Congé',
};
/** Type de client. Les clients de passage n'ont ni remise ni compte. */
export const CustomerType = {
    WALK_IN: 'WALK_IN',
    COMPANY: 'COMPANY',
    RESELLER: 'RESELLER',
};
export const CUSTOMER_TYPE_LABELS = {
    WALK_IN: 'Client de passage',
    COMPANY: 'Entreprise',
    RESELLER: 'Revendeur',
};
/** Types de notification. */
export const NotificationType = {
    APPOINTMENT_TODAY: 'APPOINTMENT_TODAY',
    LOW_STOCK: 'LOW_STOCK',
    UNPAID_INVOICE: 'UNPAID_INVOICE',
    VEHICLE_READY: 'VEHICLE_READY',
    PURCHASE_RECEIVED: 'PURCHASE_RECEIVED',
};
//# sourceMappingURL=enums.js.map